var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 33,
    viewBox: "0 0 165 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1719_8569",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 0.5H0.519531V32.5H32.5195V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1719_8569)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1719_8569",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 0.5H0.519531V32.5H32.5195V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1719_8569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2289 13.5971C30.9548 11.4181 30.7049 9.03108 29.5439 7.04913C27.7979 4.00913 24.2879 2.44513 20.8599 3.18113C19.3348 1.46308 17.1439 0.486105 14.8468 0.500149C11.3428 0.492149 8.23386 2.74815 7.1559 6.0821C4.90488 6.54308 2.96186 7.95215 1.82488 9.94913C0.0658611 12.9811 0.466838 16.8031 2.81688 19.4031C2.09084 21.5821 2.34088 23.9691 3.50186 25.9511C5.2479 28.9911 8.75786 30.5551 12.1859 29.8191C13.7099 31.5371 15.9019 32.5141 18.1988 32.4991C21.7049 32.5081 24.8148 30.2501 25.8929 26.9131C28.1439 26.4521 30.0868 25.0431 31.2239 23.0461C32.9809 20.0141 32.5788 16.1951 30.2299 13.5951L30.2289 13.5971ZM18.2009 30.4081C16.7979 30.4101 15.4388 29.9191 14.3619 29.0201C14.4108 28.9941 14.4959 28.9471 14.5508 28.9131L20.9228 25.2331C21.2489 25.0481 21.4489 24.7011 21.4468 24.3261V15.3431L24.1399 16.8981C24.1689 16.9121 24.1879 16.9401 24.1919 16.9721V24.4111C24.1879 27.7191 21.5089 30.4011 18.2009 30.4081ZM5.31688 24.9051C4.61386 23.6911 4.36088 22.2681 4.60186 20.8871C4.64888 20.9151 4.7319 20.9661 4.79084 21.0001L11.1628 24.6801C11.4859 24.8691 11.8859 24.8691 12.2099 24.6801L19.9889 20.1881V23.2981C19.9908 23.3301 19.9759 23.3611 19.9508 23.3811L13.5099 27.1001C10.6409 28.7521 6.97688 27.7701 5.31786 24.9051H5.31688ZM3.6399 10.9961C4.3399 9.78015 5.44488 8.8501 6.76088 8.36708C6.76088 8.4221 6.75786 8.51908 6.75786 8.58708V15.9481C6.7559 16.3221 6.9559 16.6691 7.28088 16.8541L15.0599 21.3451L12.3668 22.9001C12.3399 22.9181 12.3059 22.9211 12.2759 22.9081L5.83386 19.1861C2.97084 17.5281 1.98888 13.8651 3.63884 10.9971L3.6399 10.9961ZM25.7659 16.1451L17.9868 11.6531L20.6799 10.0991C20.7068 10.0811 20.7409 10.0781 20.7708 10.0911L27.2129 13.8101C30.0809 15.4671 31.0639 19.1361 29.4068 22.0041C28.7059 23.2181 27.6019 24.1481 26.2868 24.6321V17.0511C26.2899 16.6771 26.0908 16.3311 25.7668 16.1451H25.7659ZM28.4459 12.1111C28.3988 12.0821 28.3159 12.0321 28.2569 11.9981L21.8849 8.3181C21.5619 8.12913 21.1619 8.12913 20.8379 8.3181L13.0588 12.8101V9.70015C13.0569 9.66815 13.0719 9.63713 13.0969 9.61713L19.5379 5.90113C22.4068 4.2461 26.0748 5.23108 27.7289 8.10113C28.4279 9.31313 28.6809 10.7321 28.4439 12.1111H28.4459ZM11.5948 17.6541L8.90088 16.0991C8.8719 16.0851 8.85288 16.0571 8.84888 16.0251V8.5861C8.85084 5.27411 11.5379 2.59011 14.8499 2.59215C16.2508 2.59215 17.6068 3.08415 18.6839 3.98015C18.6348 4.0061 18.5508 4.05313 18.4948 4.08708L12.1228 7.76708C11.7969 7.95215 11.5969 8.29811 11.5988 8.67313L11.5948 17.6521V17.6541ZM13.0579 14.5001L16.5228 12.4991L19.9879 14.4991V18.5001L16.5228 20.5001L13.0579 18.5001V14.5001Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.793 21.7801L57.0859 18.2492L57.1917 17.9426L57.0859 17.772H56.7792L55.7275 17.7072L52.1319 17.61L49.0135 17.4804L45.9923 17.3185L45.2322 17.1565L44.5195 16.2171L44.593 15.7485L45.2322 15.3187L46.1478 15.3986L48.1713 15.5368L51.2076 15.7463L53.4103 15.8759L56.6734 16.2149H57.1917L57.2651 16.0055L57.088 15.8759L56.9498 15.7463L53.8077 13.617L50.4064 11.3668L48.6248 10.0711L47.6617 9.41456L47.1758 8.79909L46.9663 7.45587L47.8409 6.49271L49.0157 6.57261L49.3159 6.65252L50.5058 7.56816L53.0475 9.5355L56.3667 11.9801L56.8526 12.3839L57.047 12.2457L57.0708 12.1485L56.8526 11.7836L55.0473 8.52052L53.121 5.20131L52.2636 3.82568L52.0369 3.00074C51.957 2.6617 51.8987 2.37664 51.8987 2.02895L52.8942 0.677084L53.4449 0.5L54.773 0.677084L55.3323 1.16298L56.1573 3.05041L57.494 6.02193L59.5672 10.0624L60.174 11.261L60.4979 12.371L60.6189 12.71H60.8283V12.5157L60.999 10.2395L61.3142 7.44507L61.6209 3.84944L61.7267 2.83662L62.2277 1.62296L63.2233 0.96646L64.0007 1.3379L64.6399 2.25354L64.5514 2.84526L64.1713 5.31577L63.4263 9.18565L62.9404 11.7771H63.2233L63.5472 11.4532L64.858 9.71258L67.0608 6.95917L68.0326 5.86645L69.1663 4.65926L69.8941 4.08483H71.2697L72.2825 5.59003L71.829 7.14489L70.4124 8.94162L69.2376 10.4641L67.5531 12.7316L66.5014 14.5456L66.5986 14.6903L66.8491 14.6666L70.6542 13.8567L72.7101 13.4853L75.1633 13.0642L76.2733 13.5825L76.3943 14.1094L75.9581 15.187L73.3342 15.8349L70.2569 16.4503L65.6743 17.5344L65.6182 17.5755L65.683 17.6554L67.7475 17.8497L68.6308 17.8972H70.7924L74.8178 18.1974L75.8695 18.8928L76.5001 19.7436L76.3943 20.3915L74.7746 21.2164L72.5892 20.6981L67.4884 19.4845L65.7391 19.0483H65.4973V19.1929L66.955 20.6182L69.6263 23.0304L72.9714 26.1402L73.142 26.909L72.7123 27.5158L72.2588 27.451L69.3196 25.2396L68.1859 24.2441L65.6182 22.0824H65.4476V22.3091L66.0393 23.1751L69.1642 27.8721L69.3261 29.3125L69.0994 29.7811L68.2895 30.064L67.3998 29.9021L65.5707 27.3344L63.6833 24.4428L62.1608 21.8513L61.9751 21.9572L61.0767 31.634L60.6556 32.1286L59.6838 32.5L58.874 31.8845L58.4442 30.889L58.874 28.9217L59.3923 26.354L59.8134 24.3132L60.1934 21.7779L60.4202 20.9357L60.4051 20.8795L60.2194 20.9033L58.3082 23.5271L55.4014 27.4553L53.1015 29.9172L52.5508 30.1353L51.5963 29.6408L51.6849 28.7575L52.2183 27.9715L55.4014 23.9223L57.3213 21.4129L58.5608 19.9639L58.5522 19.7544H58.4788L50.0242 25.244L48.519 25.4383L47.8711 24.8315L47.951 23.8359L48.2577 23.512L50.7995 21.7628L50.7908 21.7714L50.793 21.7801Z",
    fill: "#D97757"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1719_8569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.5 16.532C116.348 16.7868 112.433 18.5509 109.492 21.4921C106.551 24.4332 104.787 28.3484 104.532 32.5H104.468C104.214 28.3482 102.45 24.4328 99.5084 21.4916C96.5672 18.5504 92.6518 16.7864 88.5 16.532V16.468C92.6518 16.2136 96.5672 14.4497 99.5084 11.5084C102.45 8.56716 104.214 4.65176 104.468 0.5L104.532 0.5C104.787 4.65162 106.551 8.56677 109.492 11.5079C112.433 14.4491 116.348 16.2132 120.5 16.468V16.532Z",
    fill: "url(#paint0_radial_1719_8569)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.262 5.38269C154.876 4.0686 153.67 3.16602 152.3 3.16602H151.399C149.909 3.16602 148.632 4.23009 148.363 5.69534L146.82 14.1041L147.203 12.7939C147.588 11.4779 148.795 10.5734 150.166 10.5734H155.402L157.597 11.4288L159.714 10.5734H159.096C157.727 10.5734 156.521 9.67082 156.135 8.35675L155.262 5.38269Z",
    fill: "url(#paint1_radial_1719_8569)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.054 27.6047C142.435 28.9251 143.644 29.834 145.019 29.834H146.932C148.606 29.834 149.975 28.5 150.018 26.8269L150.226 18.7188L149.79 20.2075C149.405 21.5228 148.199 22.4266 146.828 22.4266H141.549L139.667 21.4055L137.629 22.4266H138.236C139.611 22.4266 140.82 23.3355 141.201 24.6559L142.054 27.6047Z",
    fill: "url(#paint2_radial_1719_8569)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.167 3.16602H141.474C138.419 3.16602 136.586 7.20375 135.364 11.2415C133.916 16.0251 132.021 22.4228 137.502 22.4228H142.119C143.499 22.4228 144.71 21.5105 145.09 20.1839C145.892 17.3755 147.299 12.4763 148.404 8.74682C148.966 6.85156 149.434 5.22384 150.151 4.2102C150.554 3.64192 151.225 3.16602 152.167 3.16602Z",
    fill: "url(#paint3_linear_1719_8569)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.167 3.16602H141.474C138.419 3.16602 136.586 7.20375 135.364 11.2415C133.916 16.0251 132.021 22.4228 137.502 22.4228H142.119C143.499 22.4228 144.71 21.5105 145.09 20.1839C145.892 17.3755 147.299 12.4763 148.404 8.74682C148.966 6.85156 149.434 5.22384 150.151 4.2102C150.554 3.64192 151.225 3.16602 152.167 3.16602Z",
    fill: "url(#paint4_linear_1719_8569)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.832 29.8324H155.525C158.58 29.8324 160.413 25.794 161.635 21.7556C163.083 16.9711 164.977 10.5723 159.497 10.5723H154.88C153.5 10.5723 152.288 11.4847 151.909 12.8113C151.107 15.6202 149.7 20.5204 148.595 24.2506C148.033 26.1463 147.565 27.7742 146.847 28.7881C146.445 29.3564 145.774 29.8324 144.832 29.8324Z",
    fill: "url(#paint5_radial_1719_8569)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.832 29.8324H155.525C158.58 29.8324 160.413 25.794 161.635 21.7556C163.083 16.9711 164.977 10.5723 159.497 10.5723H154.88C153.5 10.5723 152.288 11.4847 151.909 12.8113C151.107 15.6202 149.7 20.5204 148.595 24.2506C148.033 26.1463 147.565 27.7742 146.847 28.7881C146.445 29.3564 145.774 29.8324 144.832 29.8324Z",
    fill: "url(#paint6_linear_1719_8569)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1719_8569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.676 13.506) rotate(18.6832) scale(34.06 272.842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1BA1E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1719_8569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.837 14.1756) rotate(-129.304) scale(11.5355 10.8471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955758,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773185,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1719_8569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.914 22.3787) rotate(51.84) scale(10.6608 10.3413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1719_8569",
    x1: 140.834,
    y1: 5.49935,
    x2: 142.36,
    y2: 23.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156162,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487484,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652394,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937361,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1719_8569",
    x1: 142.167,
    y1: 3.16602,
    x2: 143,
    y2: 22.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1719_8569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.046 8.6866) rotate(109.274) scale(25.5915 30.6578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661714,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1719_8569",
    x1: 160.891,
    y1: 9.3964,
    x2: 160.88,
    y2: 14.6422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581535,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708063,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1719_8569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(88.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcons);
export default __webpack_public_path__ + "static/media/ai-icons.0ede8d1dc658e13bab53e7a324ec9bbb.svg";
export { ForwardRef as ReactComponent };